module.exports = __webpack_public_path__ + "static/media/welcome__image.5463ecd0.svg";